import * as React from "react";
const SvgFiRrInteractive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-interactive_svg__a)">
      <path d="M23.707 22.293 20.9 19.489l2.789-2.79a1 1 0 0 0-.365-1.645l-8.97-3.254a2 2 0 0 0-2.56 2.56l3.263 8.969a1 1 0 0 0 1.646.365l2.786-2.794 2.804 2.804a1 1 0 0 0 1.414-1.414zM16.4 21.165l-2.724-7.49 7.49 2.724z" />
      <path d="M10 20a10 10 0 1 1 10-10 1 1 0 0 1-2 0 8 8 0 1 0-8 8 1 1 0 0 1 0 2" />
      <path d="M8.084 15.62a1 1 0 0 1-.383-.076 6 6 0 1 1 7.846-7.834.998.998 0 0 1-1.31 1.318 1 1 0 0 1-.539-.554 3.999 3.999 0 1 0-5.23 5.226 1 1 0 0 1-.384 1.924z" />
    </g>
    <defs>
      <clipPath id="fi-rr-interactive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInteractive;
